import Text from 'components/Text/Text';
import React, { useEffect, useState } from 'react';
import { Checkbox, Radio } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { TabOptions } from '../../../../../../../cronGeneratorState/cronGeneratorContext';
import style from './SpecificOfWeekSelectors.module.scss';

interface ISpecificSelectors {
	onSetResult: (value: string) => void;
}

interface ISpecificValuesItem {
	name: string;
	value: string;
	isChecked: boolean;
}

const SpecificOfWeekSelectors: React.FC<ISpecificSelectors> = ({ onSetResult }) => {
	const [checkedSpecificValues, setCheckedSpecificValues] = useState<ISpecificValuesItem[]>([]);
	const specificValues = [
		// 1/*** - prefix for sorter function
		{ name: '1/Sunday', value: 'SUN', isChecked: false },
		{ name: '2/Monday', value: 'MON', isChecked: false },
		{ name: '3/Tuesday', value: 'TUE', isChecked: false },
		{ name: '4/Wednesday', value: 'WED', isChecked: false },
		{ name: '5/Thursday', value: 'THU', isChecked: false },
		{ name: '6/Friday', value: 'FRI', isChecked: false },
		{ name: '7/Saturday', value: 'SAT', isChecked: false },
	];

	const result = checkedSpecificValues
		.sort((a, b) => parseInt(a.name) - parseInt(b.name))
		.map((el) => el.value)
		.join(',');

	useEffect(() => {
		onSetResult(result);
	}, [result]);

	useEffect(() => {
		const defaultValue = { ...specificValues[0], isChecked: true };
		!checkedSpecificValues.length && setCheckedSpecificValues([defaultValue]);
	}, []);

	const handleCheck = (e: CheckboxChangeEvent) => {
		setCheckedSpecificValues((prevState) => {
			const isChecked = e.target.checked;
			const value = e.target.value;
			const name = e.target.name as string;
			return isChecked
				? [...prevState, { name, value, isChecked }]
				: prevState.filter((el) => el.value !== value);
		});
	};

	return (
		<div className={style.radioField}>
			<div className={style.labelContainer}>
				<Radio value={TabOptions.SPECIFIC_OF_WEEK_OPTION} id={TabOptions.SPECIFIC_OF_WEEK_OPTION + 'dayTab'} />
				<label className={style.label} htmlFor={TabOptions.SPECIFIC_OF_WEEK_OPTION + 'dayTab'}>
					<Text translationNameSpace="form" translationKey="specificDayOfWeekLabel" asFragment={true} />
				</label>
			</div>
			<div className={style.selectors}>
				{specificValues.map((value) => {
					const checked = checkedSpecificValues.find((el) => el.value === value.value)?.isChecked;
					const readableName = value.name.slice(value.name.indexOf('/') + 1);
					return (
						<Checkbox
							key={value.value}
							className={style.checkBoxElement}
							name={value.name}
							value={value.value}
							checked={checked}
							onChange={handleCheck}>
							{readableName}
						</Checkbox>
					);
				})}
			</div>
		</div>
	);
};

export default React.memo(SpecificOfWeekSelectors);
